import { render } from "./form.md?vue&type=template&id=92191376"
import script from "./form.md?vue&type=script&lang=js"
export * from "./form.md?vue&type=script&lang=js"
script.render = render

export default script